const consts = {
  ENGLISH: "English",
  ESPANOL: "Español",
  Name_English: "Name",
  Name_Espanol: "Nombre",
  Phone_English: "Phone",
  Phone_Espanol: "Teléfono",
  Email_English: "Email",
  Email_Espanol: "Correo Electrónico",
  EventType_English: "Event Type",
  EventType_Espanol: "Tipo de Evento",
  ReserveDuration_English: "Select Duration",
  ReserveDuration_Espanol: "Seleccionar Duración",
  Time_English: "Time",
  Time_Espanol: "Tiempo",
  Date_English: "Date",
  Date_Espanol: "Fecha",
  Submit_English: "Submit",
  Submit_Espanol: "Enviar",
  // main
  HeaderText_English: "Reserve Your Date",
  HeaderText_Espanol: "Reserva Tu Fecha Aquí",
  // footer
  FooterText_English: "Your ideal space for unforgettable events.",
  FooterText_Espanol: "Tu lugar ideal para celebraciones inolvidables.",
  Address: "811 Foreman Dr, Lafayette, LA 70506",
  // Response
  Response_Success_English: "Thanks! Your reservation was submitted.",
  Response_Success_Espanol: "¡Gracias! Tu reservación ha sido enviada.",
  Response_Error_English:
    "Error submitting your reservation. Please try again.",
  Response_Error_Espanol:
    "Error al enviar tu reservación. Por favor, inténtalo de nuevo.",
};

export default consts;
